<template>
  <div class="boxs">
    <el-dialog :visible.sync="showScheme" v-if="showScheme" @close="closeDialog" :close-on-click-modal='false'
      width="1300px" style="overflow: hidden; height: 100%">
      <div class="Boxsd">
        <div class="digTitle">
          <span>{{bigTitle}}</span>
          <span @click="call">确定调用</span>
        </div>
        <div class="repeat" v-if="isRespect">
          <p>当前选择调用方案中：</p>
          <p style="height:250px">
            <el-scrollbar style="height: 100%; width: 100%">
              <span v-for="(item,index) in repeatData" :key="index">{{item}}、</span>使用周期和现有的方案有重复。
              请确认是否仍要调用此项？
            </el-scrollbar>
          </p>
          <div class="btnBoxs">
            <span @click="repeatCall">忽略重复</span>
            <span @click="confirmCall">已知晓重复、去修改</span>
          </div>
        </div>
        <div class="repeat" v-if="isRespectEducation">
          <p>
            选择的内容与现有的宣教内容有重复，是否再次使用此模板链宣教内容？
          </p>
          <div class="btnBoxs">
            <span @click="repeatCallEducation">保持原有内容</span>
            <span @click="confirmCallEducation">使用此内容</span>
          </div>
        </div>
        <div class="repeat" v-if="isRespectCourse">
          <p>
            选择的内容与现有的培训教程内容有重复，是否再次使用此模板链培训教程内容？
          </p>
          <div class="btnBoxs">
            <span @click="repeatCallCourse ">保持原有内容</span>
            <span @click="confirmCallCourse ">使用此内容</span>
          </div>
        </div>
        <div class="popupBox">
          <div class="headerBox">
            <div class="operate">
              <div class="leftCon">
                <el-checkbox :indeterminate="indeterminate" v-model="ischeckAll" @change="handleCheckAllChange">全选
                </el-checkbox>
              </div>
              <div class="rightCon">
                <img src="@/assets/images/timeTab1.png" />
                <el-select v-model="step" size="small" class="selects" placeholder="时间筛选" @change="stepChange">
                  <el-option v-for="item in timeTab" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="timeQuantum" v-for="(item, index) in headerTime" :key="index">
              <div class="timeQuantumName">{{ item.name }}</div>
              <div class="dayBox">
                <span v-for="(items, indexs) in item.time" :key="indexs">{{
                  items
                }}</span>
              </div>
            </div>
          </div>
          <el-scrollbar style="height: calc(100% - 130px)">
            <div class="table-body">
              <div v-for="(partition, partitionIndex) in distributorsInfo" :key="partitionIndex" class="tabelHead">
                <div class="selection">
                  <el-checkbox :indeterminate="partition.indeterminate" v-model="partition.selected" @change="
                      handleCheckedCountryAllChange(
                        partitionIndex,
                        partition.itemType,
                        $event
                      )
                    " :key="partitionIndex"></el-checkbox>
                  <div class="width185">
                    <p>{{ partition.itemTypeName }}</p>
                  </div>
                </div>
                <div class="drugListBox">
                  <ul class="drugList">
                    <li v-for="(country,countryIndex ) in partition.itemList" :key="countryIndex"
                      :class="country.selected ? 'cur' : ''">
                      <div class="leftcons">
                        <el-checkbox v-model="country.selected" @change="
                            handleCheckedCountryChange(
                              partitionIndex,
                              country.id,
                              partition.itemType,
                              $event
                            )
                          " :label="country">{{ country.itemName }}</el-checkbox>
                      </div>
                      <div class="rightLineTime">
                        <div class="lineTimeList" v-for="(items, indexs) in country.itemTimeList" :key="indexs">
                          <div class="lineBox" v-for="(time, indexTime) in items.time" :key="indexTime"
                            v-if="getWidth(time) != 0" :style="{
                              background: partition.bgColor,
                              width: getWidth(time),
                              marginLeft:getLeft(time, indexTime, items.time),
                            }">
                            <span :style="{ borderColor: partition.bgColor }"></span>
                            <span :style="{ borderColor: partition.bgColor }"></span>
                            <!-- 药物详情 -->
                            <div class="drugDetailed" v-if="partition.itemType==1">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta"></div>
                              <div class="cont">
                                <p>药品名称：{{ country.itemName }}</p>
                                <p>频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>处方属性：{{country.attrs == 1 ? "长期" : "短期"}}</p>
                                <p v-if="country.attrs == 2">短期时间：{{ country.shortDays}}{{ country.shortDaysType }}</p>
                                <p>单次用量（用药医嘱）：{{country.useDosageName}}</p>
                                <p>总用量（规格）：{{ country.specifications }}</p>
                                <p>备注：{{ country.description }}</p>
                                <p>药物治疗方案开始时间：{{timeQuantumMap[country.startTimeType]}}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>
                            </div>
                            <!--功能训练详情  -->
                            <div class="drugDetailed" v-if="partition.itemType==2">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta"></div>
                              <div class="cont">
                                <p>训练教程：{{ country.courseName }}</p>
                                <p>训练章节：{{ country.itemName }}</p>
                                <!-- <p>训练总时长：{{ country.days }}{{country.daysType}}</p> -->
                                <p>单次训练时长：{{country.duration.split(',')[0]+ '-' + country.duration.split(',')[1]+country.duration.split(',')[2]}}</p>
                                <p>训练频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>训练属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>短期训练属性：{{country.shortDays}}{{country.shortDaysType}}</p>
                                <p>训练方案开始时间：{{ timeQuantumMap[country.startTimeType] }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>

                            </div>
                            <!-- 运动处方详情 -->
                            <div class="drugDetailed" style="top:-236px" v-if="partition.itemType==9">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta health-trigle-style"></div>
                              <div class="cont">
                                <p>运动类型：{{ country.courseName }}</p>
                                <p>运动项目：{{ country.itemName }}</p>
                                <p>运动时长：{{ country.days }}{{country.daysType}}</p>
                                <p>单次运动时长：{{country.duration.split(',')[0]+ '-' + country.duration.split(',')[1]+country.duration.split(',')[2]}}</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>运动属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>短期运动属性：{{country.shortDays}}{{country.shortDaysType}}</p>
                                <p>运动处方方案开始时间：{{ timeQuantumMap[country.startTimeType] }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>
                            </div>
                            <!-- 健康宣教详情 -->
                            <div class="drugDetailed" v-if="partition.itemType==8">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta"></div>
                              <div class="cont">
                                <!-- <p>宣教疾病类型：{{ country.itemName }}</p> -->
                                <p>宣教标题：{{ country.courseName }}</p>
                                <p>宣教频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p>展示标题：{{country.title}}</p>
                                <p>展示优势：{{ country.advantage }}</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>宣教属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>短期宣教属性：{{country.shortDays}}{{country.shortDaysType}}</p>
                                <p>健康宣教备注：{{country.description}}</p>
                                <p>健康宣教方案开始时间：{{ timeQuantumMap[country.startTimeType] }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>
                            </div>
                            <!-- 评估详情 -->
                            <div class="drugDetailed" v-if="partition.itemType==4">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta"></div>
                              <div class="cont">
                                <p>评估名称：{{ country.itemName }}</p>
                                <p>评估方式：{{ country.method }}</p>
                                <p>评估类型：{{ country.executeType }}</p>
                                <p>评估频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>评估属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>短期评估属性：{{country.shortDays}}{{country.shortDaysType}}</p>
                                <p>评估内容备注：{{country.description}}</p>
                                <p>评估方案开始时间：{{ timeQuantumMap[country.startTimeType] }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>
                            </div>
                            <!-- 随访详情-->
                            <div class="drugDetailed" v-if="partition.itemType==3">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta"></div>
                              <div class="cont">
                                <p>随访名称：{{ country.itemName }}</p>
                                <p>随访方式：{{ country.method }}</p>
                                <p>随访类型：{{ country.executeType }}</p>
                                <p>随访频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>随访属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>短期随访属性：{{country.shortDays}}{{country.shortDaysType}}</p>
                                <p>随访内容备注：{{country.description}}</p>
                                <p>随访方案开始时间：{{ timeQuantumMap[country.startTimeType] }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>
                            </div>
                            <!-- 复诊计划详情 -->
                            <div class="drugDetailed" v-if="partition.itemType==5">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta"></div>
                              <div class="cont">
                                <p>复诊名称：{{ country.itemName }}</p>
                                <p>提醒时间：{{ country.remindDate | filtersRemind }}</p>
                                <!-- <p>复诊方式：{{ country.method }}</p> -->
                                <!-- <p>复诊类型：{{ country.executeType }}</p> -->
                                <p>复诊频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>复诊属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>短期复诊属性：{{country.shortDays}}{{country.shortDaysType}}</p>
                                <p>复诊计划注意事项：{{country.refName}}</p>
                                <p>复诊内容：{{country.advantage}}</p>
                                <!-- <p>复诊内容备注：{{country.description}}</p> -->
                                <p>复诊方案开始时间：{{ country.schemeTimeAxisName }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                                <p>是否需要回传检查报告：{{ country.checkStatus?'是':'否'}}</p>
                              </div>
                            </div>
                            <!-- 日常提醒详情 -->
                            <div class="drugDetailed" v-if="partition.itemType==6">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta"></div>
                              <div class="cont">
                                <p>提醒名称：{{ country.itemName }}</p>
                                <p>提醒方式：{{ country.method }}</p>
                                <p>提醒类型：{{ country.executeType }}</p>
                                <p>提醒频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>提醒属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>短期提醒属性：{{country.shortDays}}{{country.shortDaysType}}</p>
                                <p>提醒内容备注：{{country.description}}</p>
                                <p>提醒方案开始时间：{{ timeQuantumMap[country.startTimeType] }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>
                            </div>
                            <!-- 疗程管理师任务 -->
                            <div class="drugDetailed" v-if="partition.itemType==7">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta"></div>
                              <div class="cont">
                                <p>疗程名称：{{ country.itemName }}</p>
                                <p>疗程方式：{{ country.method }}</p>
                                <p>疗程类型：{{ country.executeType }}</p>
                                <p>疗程频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>疗程属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>短期疗程属性：{{country.shortDays}}{{country.shortDaysType}}</p>
                                <p>疗程内容备注：{{country.description}}</p>
                                <p>疗程方案开始时间：{{ timeQuantumMap[country.startTimeType] }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>
                            </div>
                            <!-- 重点指标详情 -->
                            <div class="drugDetailed sport-style" style="top:unset;bottom:-15px" v-if="partition.itemType==10">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta health-trigle-style"></div>
                              <div class="cont">
                                <p>任务名称：{{ country.itemName }}</p>
                                <p>获取方式：{{ methodObj[country.method] }}</p>
                                <p v-if="country.method == 24">随手记小工具：{{$toolsName(country.toolTypeId) }}</p>
                                <p>内容备注：{{country.description}}</p>
                                <p>展示标题：{{country.title}}</p>
                                <p>展示优势：{{ country.advantage }}</p>
                                <p>收集频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>收集属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>任务收集开始时间：{{ country.schemeTimeAxisName }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>
                            </div>
                          </div>
                          <div v-for="(time, indexTime) in items.time" :key="indexTime" class="width0"
                            v-if="getWidth(time) == 0" :style="{
                              borderColor: partition.bgColor,
                              marginLeft: getLeft(time, indexTime, items.time),
                            }">
                            <!-- 药物详情 -->
                            <div class="drugDetailed" v-if="partition.itemType==1">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta"></div>
                              <div class="cont">
                                <p>药品名称：{{ country.itemName }}</p>
                                <p>频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>处方属性：{{country.attrs == 1 ? "长期" : "短期"}}</p>
                                <p v-if="country.attrs == 2">短期时间：{{ country.shortDays}}{{ country.shortDaysType }}</p>
                                <p>单次用量（用药医嘱）：{{country.useDosageName}}</p>
                                <p>总用量（规格）：{{ country.specifications }}</p>
                                <p>备注：{{ country.description }}</p>
                                <p>药物治疗方案开始时间：{{timeQuantumMap[country.startTimeType]}}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>
                            </div>
                            <!--功能训练详情  -->
                            <div class="drugDetailed" v-if="partition.itemType==2">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta"></div>
                              <div class="cont">
                                <p>训练教程：{{ country.courseName }}</p>
                                <p>训练章节：{{ country.itemName }}</p>
                                <!-- <p>训练总时长：{{ country.days }}{{country.daysType}}</p> -->
                                <p>单次训练时长：{{country.duration.split(',')[0]+ '-' + country.duration.split(',')[1]+country.duration.split(',')[2]}}</p>
                                <p>训练频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>训练属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>短期训练属性：{{country.shortDays}}{{country.shortDaysType}}</p>
                                <p>训练方案开始时间：{{ timeQuantumMap[country.startTimeType] }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>

                            </div>
                            <!-- 运动处方详情 -->
                            <div class="drugDetailed" style="top:-236px" v-if="partition.itemType==9">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta health-trigle-style"></div>
                              <div class="cont">
                                <p>运动类型：{{ country.courseName }}</p>
                                <p>运动项目：{{ country.itemName }}</p>
                                <p>运动时长：{{ country.days }}{{country.daysType}}</p>
                                <p>单次运动时长：{{country.duration.split(',')[0]+ '-' + country.duration.split(',')[1]+country.duration.split(',')[2]}}</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>运动属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>短期运动属性：{{country.shortDays}}{{country.shortDaysType}}</p>
                                <p>运动处方方案开始时间：{{ timeQuantumMap[country.startTimeType] }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>
                            </div>
                            <!-- 健康宣教详情 -->
                            <div class="drugDetailed" v-if="partition.itemType==8">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta"></div>
                              <div class="cont">
                                <!-- <p>宣教疾病类型：{{ country.itemName }}</p> -->
                                <p>宣教标题：{{ country.courseName }}</p>
                                <p>宣教频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p>展示标题：{{country.title}}</p>
                                <p>展示优势：{{ country.advantage }}</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>宣教属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>短期宣教属性：{{country.shortDays}}{{country.shortDaysType}}</p>
                                <p>健康宣教备注：{{country.description}}</p>
                                <p>健康宣教方案开始时间：{{ timeQuantumMap[country.startTimeType] }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>
                            </div>
                            <!-- 评估详情 -->
                            <div class="drugDetailed" v-if="partition.itemType==4">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta"></div>
                              <div class="cont">
                                <p>评估名称：{{ country.itemName }}</p>
                                <p>评估方式：{{ country.method }}</p>
                                <p>评估类型：{{ country.executeType }}</p>
                                <p>评估频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>评估属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>短期评估属性：{{country.shortDays}}{{country.shortDaysType}}</p>
                                <p>评估内容备注：{{country.description}}</p>
                                <p>评估方案开始时间：{{ timeQuantumMap[country.startTimeType] }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>
                            </div>
                            <!-- 随访详情-->
                            <div class="drugDetailed" v-if="partition.itemType==3">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta"></div>
                              <div class="cont">
                                <p>随访名称：{{ country.itemName }}</p>
                                <p>随访方式：{{ country.method }}</p>
                                <p>随访类型：{{ country.executeType }}</p>
                                <p>随访频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>随访属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>短期随访属性：{{country.shortDays}}{{country.shortDaysType}}</p>
                                <p>随访内容备注：{{country.description}}</p>
                                <p>随访方案开始时间：{{ timeQuantumMap[country.startTimeType] }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>
                            </div>
                            <!-- 复诊计划详情 -->
                            <div class="drugDetailed" v-if="partition.itemType==5">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta"></div>
                              <div class="cont">
                                <p>复诊名称：{{ country.itemName }}</p>
                                <p>提醒时间：{{ country.remindDate | filtersRemind }}</p>
                                <!-- <p>复诊方式：{{ country.method }}</p> -->
                                <!-- <p>复诊类型：{{ country.executeType }}</p> -->
                                <p>复诊频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>复诊属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>短期复诊属性：{{country.shortDays}}{{country.shortDaysType}}</p>
                                <p>复诊计划注意事项：{{country.refName}}</p>
                                <p>复诊内容：{{country.advantage}}</p>
                                <!-- <p>复诊内容备注：{{country.description}}</p> -->
                                <p>复诊方案开始时间：{{ country.schemeTimeAxisName }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                                <p>是否需要回传检查报告：{{ country.checkStatus?'是':'否'}}</p>
                              </div>
                            </div>
                            <!-- 日常提醒详情 -->
                            <div class="drugDetailed" v-if="partition.itemType==6">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta"></div>
                              <div class="cont">
                                <p>提醒名称：{{ country.itemName }}</p>
                                <p>提醒方式：{{ country.method }}</p>
                                <p>提醒类型：{{ country.executeType }}</p>
                                <p>提醒频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>提醒属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>短期提醒属性：{{country.shortDays}}{{country.shortDaysType}}</p>
                                <p>提醒内容备注：{{country.description}}</p>
                                <p>提醒方案开始时间：{{ timeQuantumMap[country.startTimeType] }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>
                            </div>
                            <!-- 疗程管理师任务 -->
                            <div class="drugDetailed" v-if="partition.itemType==7">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta"></div>
                              <div class="cont">
                                <p>疗程名称：{{ country.itemName }}</p>
                                <p>疗程方式：{{ country.method }}</p>
                                <p>疗程类型：{{ country.executeType }}</p>
                                <p>疗程频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>疗程属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>短期疗程属性：{{country.shortDays}}{{country.shortDaysType}}</p>
                                <p>疗程内容备注：{{country.description}}</p>
                                <p>疗程方案开始时间：{{ timeQuantumMap[country.startTimeType] }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>
                            </div>
                            <!-- 重点指标详情 -->
                            <div class="drugDetailed sport-style" style="top:unset;bottom:-15px" v-if="partition.itemType==10">
                              <div class="titleName">{{ partition.itemTypeName }}</div>
                              <div class="delta health-trigle-style"></div>
                              <div class="cont">
                                <p>任务名称：{{ country.itemName }}</p>
                                <p>获取方式：{{ methodObj[country.method] }}</p>
                                <p v-if="country.method == 24">随手记小工具：{{$toolsName(country.toolTypeId) }}</p>
                                <p>内容备注：{{country.description}}</p>
                                <p>展示标题：{{country.title}}</p>
                                <p>展示优势：{{ country.advantage }}</p>
                                <p>收集频率：{{ country.cycle }}{{ country.cycleType}}{{ country.cycleCount}}次</p>
                                <p v-if="country.remindDate && country.remindDate != ''">提前：{{ $timeNumFun(country.remindDate) }}天</p>
                                <p>收集属性：{{ country.attrs==1?'长期':'短期'}}</p>
                                <p>任务收集开始时间：{{ country.schemeTimeAxisName }}</p>
                                <p>与开始时间间隔：{{country.startIntervalTime}}{{country.startIntervalType}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {getGanttTimeAxis} from "@/api/timeAxis"
import { chart2, call } from "../../api/scheme";
import local from "@/utils/local.js";
export default {
  name: "deliverySetting",
  components: {},
  props: {},
  filters:{
    filtersRemind(val) {
      if (val == 1) {
        return "提前1天";
      }
      if (val == 2) {
        return "提前3天";
      }
      if (val == 3) {
        return "提前5天";
      }
      if (val == 4) {
        return "提前7天";
      }
    },
  },
  data() {
    return {
      lockCall: false,
      methodObj: {
        21: '问卷量表',
        22: '健康工具',
        23: '病历上传',
        24: '随手记工具',
      },
      showScheme: false,
      timeTab: [
        {
          label: "5天",
          value: 5
        },
        {
          label: "10天",
          value: 10
        },
        {
          label: "20天",
          value: 20
        },
        {
          label: "30天",
          value: 30
        }
      ],
      step: 5,
      width: "",
      left: "",
      times: "",
      timeQuantumMap: {
        1: "服务开始时间",
        3: "⼊案时间",
        4: "服务启动时间",
        5: "首次⼊案时间",
        6: "首次手术时间",
        7: "首次出院时间",
        8: "线上随访时间",
        9: "线下随访时间",
        10: "服务结束时间",
        11: "化疗时间"
      },
      distributorsInfo: [],
      ischeckAll: false, //
      setDistributorDailog: false,
      cancelDistributorDailog: false,
      distributorForm: {
        vendorName: "",
        senderName: ""
      },
      indeterminate: false,
      headerTime: [],
      temp: {
        timeUnit: "5",
        schemeId: "",
        schemeType: "scheme"
      },
      temp2: {
        fromSchemeId: "",
        itemIdList: [],
        schemeId: "",
        type: ""
      },
      isRespect: false,
      isRespectEducation: false,
      isRespectCourse: false,
      repeatData: "",
      bigTitle: "",
      respectInfo: ""
    };
  },
  computed: {},
  mounted() {},
  methods: {
    //清空
    closeDialog() {
      this.isRespect = false;
      this.isRespectCourse = false;
      this.isRespectEducation = false;
      this.ischeckAll = false;
      this.indeterminate = false;
      this.temp2.type = "";
      this.temp2.functionalTraining = "";
      this.temp2.healthEducation = "";
    },
    handleCheckAllChange(e) {
      //一级change事件
      this.ischeckAll = e;
      this.indeterminate = false;
      for (var i = 0, len = this.distributorsInfo.length; i < len; i++) {
        //二级全选反选
        this.distributorsInfo[i].selected = e;
        this.distributorsInfo[i].indeterminate = false; //去掉二级不确定状态
        for (
          var j = 0, len1 = this.distributorsInfo[i].itemList.length;
          j < len1;
          j++
        ) {
          //三级全选反选
          this.distributorsInfo[i].itemList[j].selected = e;
        }
      }
    },
    handleCheckedCountryAllChange(index, topId, e) {
      //二级change事件
      this.distributorsInfo[index].selected = e; //二级勾选后，子级全部勾选或者取消
      this.distributorsInfo[index].indeterminate = false; //去掉二级不确定状态
      var childrenArray = this.distributorsInfo[index].itemList;
      if (childrenArray)
        for (var i = 0, len = childrenArray.length; i < len; i++)
          childrenArray[i].selected = e;

      this.getIsCheckAll();
    },
    handleCheckedCountryChange(topIndex, sonId, topId, e) {
      //三级change事件
      var childrenArray = this.distributorsInfo[topIndex].itemList;
      var tickCount = 0,
        unTickCount = 0,
        len = childrenArray.length;
      for (var i = 0; i < len; i++) {
        if (sonId == childrenArray[i].id) childrenArray[i].selected = e;
        if (childrenArray[i].selected == true) tickCount++;
        if (childrenArray[i].selected == false) unTickCount++;
      }
      if (tickCount == len) {
        //三级级全勾选
        this.distributorsInfo[topIndex].selected = true;
        this.distributorsInfo[topIndex].indeterminate = false;
      } else if (unTickCount == len) {
        //三级级全不勾选
        this.distributorsInfo[topIndex].selected = false;
        this.distributorsInfo[topIndex].indeterminate = false;
      } else {
        this.distributorsInfo[topIndex].selected = false;
        this.distributorsInfo[topIndex].indeterminate = true; //添加二级不确定状态
      }

      this.getIsCheckAll();
    },
    getIsCheckAll() {
      var tickCount = 0,
        unTickCount = 0,
        indeterminateCount = 0,
        ArrLength = this.distributorsInfo.length;
      for (var j = 0; j < ArrLength; j++) {
        //全选checkbox状态
        if (this.distributorsInfo[j].selected == true) tickCount++;
        if (this.distributorsInfo[j].selected == false) unTickCount++;
        if (this.distributorsInfo[j].indeterminate == true)
          indeterminateCount++;
      }
      if (tickCount == ArrLength) {
        //二级全勾选
        this.ischeckAll = true;
        this.indeterminate = false;
      } else if (unTickCount == ArrLength) {
        //二级全不勾选
        this.ischeckAll = false;
        if (indeterminateCount > 0) {
          this.indeterminate = true;
        } else {
          this.indeterminate = false;
        }
      } else {
        this.ischeckAll = false;
        this.indeterminate = true; //添加一级不确定状态
      }
    },

    showSetDistributorDailog() {
      this.setDistributorDailog = true;
    },
    showCancelDistributorDailog() {
      this.cancelDistributorDailog = true;
    },
    //生成头不时间间隔数据
    async getHeadrTime(step) {
      let arr = [];
      for (let i = 1; i < 5; i++) {
        arr.push("T" + i * step);
      }
      let res = await getGanttTimeAxis({
        schemeId: this.temp.schemeId,
        schemeType: "scheme",
        timeUnit: this.temp.timeUnit,
        isDraft: sessionStorage.getItem("ADDRESS") == 'doctorScheme' ? false : true,
        schemeTimeAxisId: ''
      });
      if (res.code === 0) {
        res.data.schemeTimeAxisList.map(v => {
          v.time = arr
        })
        this.headerTime = res.data.schemeTimeAxisList;
      }
      // this.headerTime = [
      //   {
      //     name: "入案时间",
      //     time: arr
      //   },
      //   {
      //     name: "服务启动时间",
      //     time: arr
      //   },
      //   {
      //     name: "首次入院时间",
      //     time: arr
      //   },
      //   {
      //     name: "线上随访时间",
      //     time: arr
      //   },

      //   {
      //     name: "线下随访时间",
      //     time: arr
      //   },
      //   {
      //     name: "首次手术时间",
      //     time: arr
      //   },
      //   {
      //     name: "化疗时间",
      //     time: arr
      //   },
      //   {
      //     name: "首次出院时间",
      //     time: arr
      //   },

      //   // {
      //   //   name: "线上问诊时间",
      //   //   time: arr,
      //   // },
      //   {
      //     name: "服务结束时间",
      //     time: arr
      //   }
      // ];
    },
    stepChange() {
      this.getHeadrTime(this.step);
      this.temp.timeUnit = this.step;
      this.getCharts();
      this.ischeckAll = false;
    },
    //动态计算宽度
    getWidth(item) {
      let width;
      if (item.end - item.start < this.step) {
        width = 0;
      } else {
        let smallWidth = (item.end - item.start) * (1 / this.step);
        width = smallWidth > 0 ? (smallWidth / 3) * 100 + "%" : 0;
      }
      return width;
    },
    //动态计算margin-left
    getLeft(item, index, arr) {
      if (index == 0) {
        let left = (item.start - this.step) * (1 / this.step);
        let marginLeft = (left / 3) * 100 + "%";
        return marginLeft;
      } else {
        let left = (arr[index].start - arr[index - 1].end) * (1 / this.step);
        let marginLeft = (left / 3) * 100 + "%";
        return marginLeft;
      }
    },
    //调用弹窗
    useDialog(row, index) {
      this.showScheme = true;
      this.temp.schemeId = row.id;
      this.temp2.schemeId = sessionStorage.getItem("SCHEME_ID");
      this.temp2.fromSchemeId = row.id;
      this.getHeadrTime(this.step);
      this.getCharts();
    },
    //获取第二个图数据
    async getCharts() {
      this.temp.schemeType = "scheme";
      // chart2(this.temp).then(res => {
      //   this.distributorsInfo = res.data.list;
      //   this.bigTitle = res.data.titleName;
      // });
      let res = await getGanttTimeAxis({
        schemeId: this.temp.schemeId,
        schemeType: this.temp.schemeType,
        timeUnit: this.temp.timeUnit,
        isDraft: sessionStorage.getItem("ADDRESS") == 'doctorScheme' ? false : true,
        schemeTimeAxisId: ''
      });
      if (res.code === 0) {
        // this.distributorsInfo = res.data.list;
        if (this.chainType == 2) {
          res.data.list.shift()
          this.distributorsInfo = res.data.list
        } else {
          this.distributorsInfo = res.data.list;
        }
        this.bigTitle = res.data.titleName
      }
    },
    //调用接口
    call() {
      // 加判断--对比已有的宣教教程，问卷内容复制来的id，如果id与引用id重复，弹框给出提示
      this.temp2.itemIdList = [];
      this.distributorsInfo.map(item => {
        for (var i = 0; i < item.itemList.length; i++) {
          if (item.itemList[i].selected) {
            this.temp2.itemIdList.push(item.itemList[i].id);
          }
        }
      });
      if (this.temp2.itemIdList.length == 0) {
        this.$message.error("请勾选方案，再调用");
        return;
      }
      if (this.lockCall) return
      this.lockCall = true
      if (sessionStorage.getItem("isMytemp") == 1) {
        this.temp2.schemeType = 'scheme';
      } else {
        this.temp2.schemeType = sessionStorage.getItem("ADDRESS");
      }
      call(this.temp2)
        .then(res => {
          this.respectInfo = res.data;
          this.lockCall = false

          if (!res.success) {
            this.$message.error(res.message);
          }
          if (res.data.code == 0) {
            this.isRespect = false;
            this.isRespectCourse = false;
            this.isRespectEducation = false;
            this.showScheme = false;
            this.temp2.type = "";
            this.temp2.functionalTraining = "";
            this.temp2.healthEducation = "";
            this.$message.success("模板调用成功");
            if (sessionStorage.getItem("isMytemp") == 1) {
              this.$router.push({
                path: "/Chaining/case-6",
                query: {
                  type: "EDIT",
                  isDraft: 1
                }
              });
            } else {
              // if (sessionStorage.getItem("fromName") == '模板链') {
              //   this.$router.push({
              //     path: "/Chaining/case-6",
              //     query: {
              //       type: "EDIT",
              //       isDraft: 1
              //     }
              //   });
              // }
              if (sessionStorage.getItem("ADDRESS") == 'doctorScheme') {
                this.$router.push({
                  path: "/Chaining/case-6",
                  query: {
                    type: "EDIT"
                  }
                });
              } else {
                this.$router.push({
                  path: "/Chaining/case-6",
                  query: {
                    type: "EDIT",
                    isDraft: 1
                  }
                });
              }
            }
            // this.$router.push({
            //   path: "/Chaining/case-6",
            //   query: {
            //     type: "EDIT",
            //     // isDraft: 1
            //   }
            // });
          } else if (res.data.code == 2) {
            this.isRespect = true;
            this.repeatData = res.data.itemNameList;
          } else if (res.data.code == 3) {
            this.isRespectCourse = res.data.functionalTraining;
            this.isRespectEducation = res.data.healthEducation;
          }
          sessionStorage.removeItem("isMytemp")
        })
        .catch(err => {
          this.lockCall = false
        });
    },
    repeatCall() {
      this.temp2.type = 1;
      if (
        !this.respectInfo.functionalTraining &&
        !this.respectInfo.healthEducation
      ) {
        this.call();
      } else {
        this.isRespect = false;
        this.isRespectCourse = this.respectInfo.functionalTraining;
        this.isRespectEducation = this.respectInfo.healthEducation;
      }
    },
    //教程
    repeatCallCourse() {
      this.temp2.type = 1;
      this.temp2.functionalTraining = 1;
      if (this.respectInfo.healthEducation) {
        this.isRespectCourse = false;
      } else {
        this.call();
      }
    },
    confirmCallCourse() {
      this.temp2.type = 1;
      this.temp2.functionalTraining = 2;
      if (this.respectInfo.healthEducation) {
        this.isRespectCourse = false;
      } else {
        this.call();
      }
    },
    //宣教
    repeatCallEducation() {
      this.temp2.type = 1;
      this.temp2.healthEducation = 1;
      if (this.respectInfo.functionalTraining) {
        this.isRespectEducation = false;
      } else {
        this.call();
      }
    },
    confirmCallEducation() {
      this.temp2.type = 1;
      this.temp2.healthEducation = 2;
      if (this.respectInfo.functionalTraining) {
        this.isRespectEducation = false;
      } else {
        this.call();
      }
    },
    confirmCall() {
      this.isRespect = false;
    }
  },
  created() {
    // this.getHeadrTime(this.step);
  },
  mounted() {
    // (async() => {
  },
  watch: {}
};
</script>

<style lang="less">
.boxs .el-dialog {
  height: calc(100% - 178px);
  .el-dialog__body {
    height: calc(100% - 50px);
  }
}
</style>
<style lang="less" scoped>
@import "../../style/module";
.health-trigle-style {
  top: unset !important;
  bottom: 12px;
}
</style>